theme.utils = {
  /**
   * Fallback default value
   */
  defaultTo: (valueArg, defaultValue) => {
    const value = valueArg;
    return value == null || value !== valueArg ? defaultValue : value;
  },

  /**
   * Generate random ID
   */
  generateRandomId: () => {
    return Math.random().toString(36).substring(2, 12);
  },

  /**
   * Check if device is mobile
   */
  isDeviceMobile() {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    ) {
      return true;
    }
    return false;
  },

  /**
   * Serialize form
   */
  serialize: (form) => {
    const arr = [];
    Array.prototype.slice.call(form.elements).forEach((field) => {
      if (
        !field.name ||
        field.disabled ||
        ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
      )
        return;
      if (field.type === 'select-multiple') {
        Array.prototype.slice.call(field.options).forEach((option) => {
          if (!option.selected) return;
          arr.push(`${encodeURIComponent(field.name)}=${encodeURIComponent(option.value)}`);
        });
        return;
      }
      if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked) return;
      arr.push(`${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`);
    });
    return arr.join('&');
  },

  /**
   * handle string to handle
   *  e.g.: product.title = "Hello Word" => handled: hello-word
   */
  handleizeString(str) {
    const x = str || '';
    return x
      .toLowerCase()
      .replace("'", '')
      .replace(/[^\w\u00C0-\u024f]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  },

  /**
   * scroll to element
   * @param {string} selector the DOM element - e.g.: #my-element
   * @param {object} options object of options
   */
  scrollToView(selector, options = {behavior: 'smooth'}) {
    const element = document.querySelector(selector);

    element.scrollIntoView(options);
  },

  /**
   * throttle function
   * @param {string} callback the function
   * @param {number} delay delay between interactions
   */
  throttle(callback, delay) {
    let inProgress = false;

    return (...args) => {
      if (inProgress) return;

      inProgress = true;
      setTimeout(() => {
        callback(...args);
        inProgress = false;
      }, delay);
    };
  },

  /**
   * debounce function
   * @param {string} callback the function
   * @param {number} delay delay between interaction is done and callback is called
   */
  debounce(callback, delay) {
    let timeout;

    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        callback(...args);
      }, delay);
    };
  },
};

export default theme.utils;
